module.exports = __webpack_public_path__ + "static/media/bg-what-we-do.08d569d3.svg";